import { render, staticRenderFns } from "./TMTeamAlunos.vue?vue&type=template&id=7e246d6e&scoped=true"
import script from "./TMTeamAlunos.vue?vue&type=script&lang=js"
export * from "./TMTeamAlunos.vue?vue&type=script&lang=js"
import style0 from "./TMTeamAlunos.vue?vue&type=style&index=0&id=7e246d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e246d6e",
  null
  
)

export default component.exports